<template>
    <div>
        <v-container class="terms-conditions pa-0">
            <v-row no-gutters>
                <v-col cols="12" md="12">
                    <v-list-item light class="pa-0">
                        <v-list-item-content>
                            <h2
                                class="text-capitalize text-subtitle-1 font-weight-bold mb-2"
                            >
                                I. {{ domainUrl }} CLUB
                            </h2>
                            <v-list-item-title
                                class="body-2 nowrap text-md-justify text-sm-left pb-4"
                            >
                                <!-- :class="{
                'black--text': !$vuetify.theme.dark,
                'white--text': $vuetify.theme.dark
              }" -->
                                By subscribing/registering to/on our
                                <a :href="websiteurl">{{ domainName }}</a>
                                website, and its sub-domains (collectively
                                referred to as “{{ domainUrl }} site”) and/or
                                any services including, registering and playing
                                betting games, participating in betting contests
                                and tournaments, provided on the
                                {{ domainUrl }} site, you agree that you have
                                read, understood and have agreed to be bound by
                                this Terms and Conditions, regardless of how you
                                subscribe to or use the services.
                            </v-list-item-title>
                            <v-list-item-title
                                class="body-2 nowrap text-md-justify text-sm-left"
                            >
                                Please note that this Privacy Policy will be
                                agreed between you and {{ domainUrl }}. (‘We’,
                                ‘Us’ or ‘Our’, as appropriate). This Privacy
                                Policy is an integrated part of
                                {{ domainUrl }}’s Terms and Conditions. We may
                                periodically make changes to this Privacy Policy
                                and will notify you of these changes by posting
                                the modified terms on our platforms. We
                                recommend that you revisit this Privacy Policy
                                regularly.Please read the Terms carefully and if
                                you do not accept the Terms, do not use, visit
                                or access any part (including, but not limited
                                to, sub-domains, source code and/or website
                                APIs, whether visible or not) of the
                                {{ domainUrl }} site. The Terms shall also apply
                                to all telephone betting and betting or gaming
                                via mobile devices including downloadable
                                applications to a mobile device (as if
                                references to your use of the Website were
                                references to your use of our telephone betting
                                and/or mobile devices betting facilities). “We”,
                                “us”, “our”, “{{ domainUrl }}” shall mean Win
                                Ventures NV and/or any of its affiliated
                                entities. For the purpose of these Terms and
                                Conditions, wherever the context so require
                                "you" or "your" or "User" or “Participant” shall
                                mean any natural or legal person who has agreed
                                to become a member of the {{ domainUrl }} site
                                by visiting the {{ domainUrl }} site as
                                registered User or a person who has used the
                                {{ domainUrl }} site either through browsing or
                                otherwise. Where you play any game, or place a
                                bet or wager, using the Website, you accept and
                                agree to be bound by, the Rules which apply to
                                the applicable products available on the Website
                                from time to time.
                            </v-list-item-title>
                            <v-list-item-title
                                class="body-2 nowrap text-md-justify text-sm-left"
                            >
                                {{ domainUrl }} one stop shop for leisure
                                gambling games including Baccarat, Teen Patti,
                                Roulette, Poker, Blackjack and sports betting
                                through which it offers cricket based, football,
                                tennis, horse racing based online betting games
                                along with live casino betting. The
                                {{ domainUrl }} site is neither affiliated by
                                nor associated to any sort of private or
                                government Sports leagues and tournaments until
                                and unless expressly stated by {{ domainUrl }}.
                                In addition to this, the {{ domainUrl }} app is
                                not related and does not claim any official
                                status with any of the official or non-official
                                sports teams and/or sportspersons.
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
// import PageTitle from '~/components/PageTitle.vue'
export default {
    components: {},
    data() {
        return {
            domainUrl: process.env.APP_TITLE,
            title: "privacy policy",
            websiteurl: "",
            domainName: ""
        }
    },
    head() {
        return {
            title: `Privacy Policy and Security - ${process.env.APP_TITLE}`,
            meta: [
                {
                    hid: "description",
                    name: "description",
                    content: `${process.env.APP_TITLE} is committed to protecting your personal information. This Privacy Policy lets you know what information we collect when you use our services.`
                },
                {
                    name: "keywords",
                    content: `Game Privacy Policy, Privacy Policies by ${process.env.APP_TITLE}`
                }
            ]
        }
    },
    created() {
        this.getVersion()
    },
    methods: {
        getVersion() {
            if (process.client) {
                this.websiteurl = window.location.origin
                this.domainName = window.location.hostname
            }
        }
    }
}
</script>

<style lang="scss"></style>
